import {getCountryByCode, loader, errorHandler, message, logout} from '@/libs/helper'
import {followUnfollow, locationListForEntity, getCountryList} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import {isEmpty, sortBy, cloneDeep, forEach, uniq, map, find} from 'lodash'
import {mapGetters}  from 'vuex'
var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
export default {
    name: 'Imprint',
    components: {'DetailMenu' : () => import('@/components/pages/InformationPortal/ProfilePage/DetailMenu/DetailMenu.vue')},
    props: {
        module: {
            type: String
        },
        details: {
            type: Object,
            default: () => {}
        },
        routeToDetailPage: {
            type: Function,
            default: () => {}
        },
        updateMetaList: {
            type: Function,
            default: () => {}
        },
        followersCount: {
            type: [Number, String]
        },
        changeUpdateFollowers: {
            type: Function,
            default: () => {}
        },
        // left menu
        selectedRecord: {
            type: Object,
            default: () => {}
        },
        createDetailShortUrl: {
            type: Function,
            default: () => {}
        },
        getFavorite: {
            type: Function,
            default: () => {}
        },
        getIconClassName: {
            type: Function,
            default: () => {}
        },
        followCollection: {
            type: Function,
            default: () => {}
        },
        getShortUrlCollection: {
            type: Function,
            default: () => {}
        },
        routeToFollowers: {
            type: Function,
            default: () => {}
        },
        routeToCollectionAboutPage: {
            type: Function,
            default: () => {}
        },
        routeFromCollectionPage: {
            type: Function,
            default: () => {}
        },
        setFavourite: {
            type: Function,
            default: () => {}
        },
        articlesCount: {
            type: Number,
            default: 0
        },
        collectionCount: {
            type: Number,
            default: 0
        },
        collectionFollowersCount: {
            type: Number,
            default: 0
        },
        dossierCount: {
            type: Number,
            default: 0
        },
        collectionArticleCount: {
            type: Number,
            default: 0
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        isDossier: {
            type: Boolean,
            default: false
        },
        collectionShortUrl: {
            type: String,
            default: ''
        },
        shortUrl: {
            type: String,
            default: ''
        },
        routeToAboutPage: {
            type: Function,
            default: () => {}
        },
        followUnfollowAction: {
            type: Function,
            default: () => {}
        },
        aboutPageClicked: {
            type: String,
            default: ''
        },
        resetAboutPageClicked: {
            type: Function,
            default: () => {}
        },
        fetchMetaDetails: {
            type: Function,
            default: () => {}
        },
        followingList: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            activeMenu: 'meta',
            searchValue: '',
            getCountryByCode,
            currentPage: 1,
            skip: 0,
            limit: 30,
            currentFollowersPage: 1,
            isEmpty,
            sortBy,
            isFetching: false,
            showWorldMap: false,
            locations: [],
            locationsToDisplay: [],
            locationIds: []
        }
    },
    computed: {
        locationCity () {
            return this.locations.map(loc => {
                return {
                    name: loc.city,
                    _id: loc._id
                }
            })
        },
        locationCountry () {
            return this.locations.map(loc => {
                return {
                    name: loc.country_name,
                    _id: loc._id
                }
            })
        },
        locationType () {
            return this.locations.map(loc => {
                return {
                    name: loc.locationtype && loc.locationtype.type && loc.locationtype.type.toLowerCase(),
                    loc_type_id: loc.location_type_id,
                    _id: loc._id
                }
            })
        },
        ...mapGetters({
            countryList: 'getCountryList'
        }),
    },
    beforeMount() {
        if (this.$route && this.$route.query && this.$route.query.type && this.$route.query.type !== undefined) {
            this.changeMenu(this.$route.query.type)
        }
        if (this.aboutPageClicked !== '') {
            this.changeMenu(this.aboutPageClicked)
        }
    },
    mounted() {
        if (this.module === 'ORGANISATION') {
            this.activeMenu = 'imprint'
        }
    },
    watch: {
        activeMenu (newValue) {
            if (newValue === 'location') this.fetchLocations()
        },
        showWorldMap () {
            // initialise map
            this.$nextTick(() => {
                this.initialiseMapBox()
            })
        },
        aboutPageClicked (value) {
            if (value !== '') {
                this.changeMenu(value)
            }
        },
        '$route' (to) {
            if (to && to.query && to.query.type && to.query.type !== undefined) {
                this.changeMenu(to.query.type)
            } 
        }
        
    },
    methods: {
        /*
         * returns the user to fetch the user's avatar.
         * */
        getURL(imageName){
            return `${process.env.VUE_APP_API_BASE_URL}/accounts/files/${imageName}?auth=${localStorage.getItem('accuraAuthToken')}`
        },
        /*
         * return the place holder image in case of error in image loading.
         * */
        onError(e) {
            let avatarURL = require('@/assets/images/author_placeholder.png');
            if (e.target.src !== avatarURL) {
                e.target.src = avatarURL;
            }
        },
        /**
         * to change the submenu
         * @param {*} menu 
         */
        changeMenu (menu) {
            // setting menu
            this.activeMenu = menu
            // clearing pagination if menu is changed
            this.clearFields()
            // if menu is followers then get the list of followers
        },

        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
           // set current page
           this.currentPage = currentPage
           // setting the skip as per the current page
           this.skip = (currentPage - 1) * this.limit
        },

        /**
         * clearing fields
         */
        clearFields () {
            this.skip = 0
            this.currentPage = 1
            this.resetAboutPageClicked('')
        },
        /**
         * to follow/unfollow any auhor
         * @param {*} module 
         * @param {*} meta 
         */
        followUnfollowImprintAction(module, meta){
            if (this.details._id === meta._id && this.details.is_admin){
                message(this, constants.messageType.WARNING, ('Managed author cannot be unfollowed'))
                return
            }

            loader(this, true)

            let body = {
                id: meta._id
            }
            if (module === constants.PUBLICATION.key) body.id = meta.publication || meta._id
            followUnfollow(body, meta.is_following ? 'unfollow' : 'follow', module.toLowerCase())
                .then(()=>{
                    loader(this, false)
                    message(this, constants.messageType.SUCCESS, `${meta.is_following ? ('Unfollowed Successfully') : ('Followed Successfully')}`);
                    this.$set(meta, 'is_following', !meta.is_following)
                    this.updateMetaList(meta, module)
                })
                .catch((error)=>{
                    loader(this, false)
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
        },
        

        initialiseMapBox () {
            if (!isEmpty(this.locationsToDisplay)) {
                // add access token for mapbox
                mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_TOKEN

                // for world map
                if (this.showWorldMap) {

                    const map = new mapboxgl.Map({
                        container: 'worldmap',
                        style: 'mapbox://styles/mapbox/streets-v11',
                        center: (this.locationsToDisplay[0] && this.locationsToDisplay[0].point && this.locationsToDisplay[0].point.coordinates),
                        zoom: 1
                    })

                    const geojson = {
                        type: 'FeatureCollection',
                        features: this.locationsToDisplay.map(loc => {
                            return {
                                type: 'Feature',
                                geometry: {
                                    type: 'Point',
                                    coordinates: loc.point && loc.point.coordinates
                                },
                                properties: {
                                    title: loc.country_name,
                                    description: loc.city
                                }
                            }
                        })
                    };

                    // add markers to map
                    for (const { geometry, properties } of geojson.features) {
                        // create a HTML element for each feature
                        const el = document.createElement('div');
                        el.className = 'marker';
                    
                        // make a marker for each feature and add to the map
                        new mapboxgl.Marker(el)
                        .setLngLat(geometry.coordinates)
                        .setPopup(
                            new mapboxgl.Popup({ offset: 25 }) // add popups
                              .setHTML(
                                `<h3>${properties.title}</h3><p>${properties.description}</p>`
                              )
                        )
                        .addTo(map);
                    }
                }

                // location list
                else {
                    // loop in locations
                    forEach(this.locationsToDisplay, (loc) => {
                        if (loc.point && loc.point.coordinates) {
                            const cityMap = new mapboxgl.Map({
                                container: `mapbox-${loc._id}`,
                                style: 'mapbox://styles/mapbox/streets-v11',
                                center: (loc.point.coordinates),
                                zoom: 9
                            })
                            const geojson = {
                                type: 'FeatureCollection',
                                features: [
                                    {
                                        type: 'Feature',
                                        geometry: {
                                            type: 'Point',
                                            coordinates: loc.point && loc.point.coordinates
                                        },
                                        properties: {
                                            title: loc.country_name,
                                            description: loc.city
                                        }
                                    }
                                ]
                            };
        
                            // add markers to map
                            for (const { geometry, properties } of geojson.features) {
                                // create a HTML element for each feature
                                const el = document.createElement('div');
                                el.className = 'marker';
                            
                                // make a marker for each feature and add to the map
                                new mapboxgl.Marker(el)
                                .setLngLat(geometry.coordinates)
                                .setPopup(
                                    new mapboxgl.Popup({ offset: 25 }) // add popups
                                      .setHTML(
                                        `<h3>${properties.title}</h3><p>${properties.description}</p>`
                                      )
                                )
                                .addTo(cityMap);
                            }
                        }
                    })
                }
            }
        },
        
        /**
         * to fetch locations
         */
        async fetchLocations () {
            try {
                // api call
                let response = await locationListForEntity(this.$route.params.id, {child_structure: false})

                // initialise
                this.locations = (response && response.result) || []
                let locationsToDisplay = cloneDeep((response && response.result) || [])

                await this.fetchCountries()

                this.locationsToDisplay = map(locationsToDisplay, location => {
                    const findCountry = find(this.countryList, {country_name: location.country_name})
                    location.displayFormat = (findCountry && findCountry.format) || [] 
                    return location
                })

                // initialise map
                this.$nextTick(() => {
                    this.initialiseMapBox()
                })
            } catch (error) {
                console.error('error-->>', error)
            }
        },

        /**
         * get map id
         */
        getMapId (id) {
            if (id) return `mapbox-${id}`
        },

        /**
         * filterLocation on city, country, type
         */
        filterLocation (event, item) {
            let locationIds = [...this.locationIds]
            // true
            if (event) {
                locationIds.push(item._id)
            } 
            // false
            else {
                locationIds = locationIds.filter(id => id !== item._id)
            }

            // filter loc to display
            this.locationsToDisplay = this.locations.filter(loc => (locationIds.includes(loc._id) || isEmpty(locationIds)))
            
            this.$nextTick(() => {
                // initialise map
                this.initialiseMapBox()
            })
            
            // assign locationIds
            this.locationIds = uniq(locationIds)
        },

        changeMapView () {
            // change view property
            this.showWorldMap = !this.showWorldMap;
            
            // update map view
            this.$nextTick(() => {
                this.initialiseMapBox()
            })
        },
        /**
         * route to member page
         */
        routeToMemberPage (member) {
            if (member.type === 'ORGANISATION') {
                this.$router.push({name: 'org-overview', params: {id: (member._id || member.id)}}).catch(() => {})
            } else this.$router.push({name: 'users-overview', params: {id: (member._id || member.id)}}).catch(() => {})
        },

        async fetchCountries () {
            if (isEmpty(this.countryList)) {
                let response = await getCountryList();
                this.countries = (response && response.list) || [];
                this.$store.dispatch('setCountryList', ((response && response.list) || []));
            }
        },
    }
}